function ready() {
	'use strict'

	// MARK: pause animation
	// Stop CSS animation on window resize
	// https://css-tricks.com/stop-animations-during-window-resizing/
	let resizeTimer
	window.addEventListener('resize', () => {
		document.body.classList.add('resize-animation-stopper')
		clearTimeout(resizeTimer)
		resizeTimer = setTimeout(() => {
			document.body.classList.remove('resize-animation-stopper')
		}, 400)
	})

	// MARK: Menu
	const menuContainer = document.querySelector('.site-header')
	// const siteNav = document.getElementById( 'site-navigation' )
	const mobileMenuButton = document.getElementById('mobile-menu')

	// Function to toggle mobile menu
	function toggleMobileMenu() {
		if (menuContainer.classList.contains('mobile-menu-open')) {
			closeMobileMenu();
		} else {
			openMobileMenu();
		}
	}

	function openMobileMenu() {
		menuContainer.classList.add('fade-in');
		mobileMenuButton.setAttribute('aria-expanded', true);
		setTimeout(() => {
			menuContainer.classList.add('mobile-menu-open');
			menuContainer.classList.remove('fade-in');
		}, 200);
	}

	function closeMobileMenu() {
		menuContainer.classList.add('fade-out');
		menuContainer.classList.remove('mobile-menu-open');
		mobileMenuButton.setAttribute('aria-expanded', false);
		setTimeout(() => {
			menuContainer.classList.remove('fade-out');
		}, 300);
	}

	if (mobileMenuButton) {
		mobileMenuButton.addEventListener('click', (e) => {
			e.preventDefault();
			toggleMobileMenu();
		});
	}

	// MARK: Menu - drop-down menu.
	const menuHasChildrenItems = document.querySelectorAll('.site-header #primary-menu .menu-item-has-children')
	const menuHasChildrenBtn = document.querySelectorAll('.site-header #primary-menu .menu-item-has-children > .toggle-dropdown')
	for (let menuChildren of menuHasChildrenBtn) {
		// get parent nodes.
		const menuParent = menuChildren.parentNode

		// Set ID and aria-labelledby for each button and drop-down
		const anchorLabel = menuChildren.textContent
		const anchorLabelStr = anchorLabel.replace(/\s+/g, '-').toLowerCase()
		menuParent.querySelector('button').setAttribute('id', anchorLabelStr)
		menuParent.querySelector('.sub-menu').setAttribute('aria-labelledby', anchorLabelStr)

		// toggle drop-down
		menuChildren.addEventListener('click', function (e) {
			e.preventDefault()

			if (menuParent.classList.contains('menu-open')) {
				// If open, close drop-down menu.
				menuParent.classList.add('fade-out')
				menuChildren.setAttribute('aria-expanded', false)
				setTimeout(function () {
					menuParent.classList.remove('menu-open')
					menuParent.classList.remove('fade-out')
				}, 300)
			} else {
				// First remove all instances of .menu-open from .menu-item-has-children
				for (let menuHasChildrenItem of menuHasChildrenItems) {
					menuHasChildrenItem.classList.remove('menu-open')

					// Then set all toggle-dropdown buttons to aria-expanded false.
					const toggleDropdowns = menuHasChildrenItem.querySelectorAll('.toggle-dropdown')
					for (let toggleDropdown of toggleDropdowns) {
						toggleDropdown.setAttribute('aria-expanded', false)
					}
				}
				// If closed, open drop-down menu.
				menuParent.classList.add('fade-in')
				menuChildren.setAttribute('aria-expanded', true)
				if (window.innerWidth < 993) {
					menuParent.classList.add('menu-open')
				}
				setTimeout(function () {
					if (window.innerWidth > 992) {
						menuParent.classList.add('menu-open')
					}
					menuParent.classList.remove('fade-in')
				}, 100)
			}
		})
	}

	// MARK: Menu - hide drop-down menu on outside click
	document.addEventListener('mouseup', function (e) {
		for (let menuChildren of menuHasChildrenBtn) {
			// get parent node.
			const menuParent = menuChildren.parentNode

			if (menuParent.classList.contains('menu-open') && e.target.closest('#site-navigation') === null) {
				menuParent.classList.remove('menu-open')
				menuChildren.setAttribute('aria-expanded', false)
			}
		}
	})

	// MARK: Menu - hide drop-down using ESC key.
	document.addEventListener('keydown', function (e) {
		const key = e.key
		for (let menuChildren of menuHasChildrenBtn) {
			// get parent node.
			const menuParent = menuChildren.parentNode

			if (menuParent.classList.contains('menu-open') && key === 'Escape') {
				menuParent.classList.remove('menu-open')
				menuChildren.setAttribute('aria-expanded', false)
				menuParent.querySelector('button').focus()
			}
		}
	})
	// end menu

	// MARK: Insert menu heros to assigned drop-downs
	//   Find all elelemnts with an ID starting with 'menu-hero-' and split the ID to get the last part.
	const menuHeroItems = document.querySelectorAll('[id^="menu-hero-"]')
	for (let menuHeroItem of menuHeroItems) {
		const menuHeroItemId = menuHeroItem.id.replace(/^menu-hero-/, '')
		// Find the corresponding button and insert the subhead hero text.
		const menuHeroSubhead = document.querySelector(`#menu-hero-${menuHeroItemId} .menu-hero-title .subhead`)
		const menuButtons = document.querySelectorAll(`button#${menuHeroItemId}`)
		for (let menuButton of menuButtons) {
			menuButton.innerHTML += menuHeroSubhead.outerHTML
		}
		// Find the corresponding button and insert the menu hero after it.
		const menuHeroButton = document.getElementById(`menu-hero-${menuHeroItemId}`)
		const menuSubmenus = document.querySelectorAll(`button#${menuHeroItemId} + .sub-menu`)
		for (let menuSubmenu of menuSubmenus) {
			menuSubmenu.insertBefore(menuHeroButton, menuSubmenu.firstChild)
			// wrap in LI for correct syntax.
			const li = document.createElement('li')
			li.classList.add('menu-hero')
			menuHeroButton.parentNode.insertBefore(li, menuHeroButton)
			li.appendChild(menuHeroButton)
		}
	}

	// MARK: Play home video and expand
	//   https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/play
	let homeVideoContainer = document.querySelector('.video-container')
	let homeVideo = document.getElementById('home-video');
	let homeVideoMuteBtn = document.getElementById('mute-button')
	let homeVideoText = document.querySelector('.home-video-text')

	if (homeVideo) {
		homeVideo.addEventListener('click', handlePlayButton, false)
		async function playVideo() {
			try {
				await homeVideo.play()
				homeVideoContainer.classList.add('playing')
			} catch (err) {
				homeVideoContainer.classList.remove('playing')
			}
		}
		function handlePlayButton() {
			if (homeVideo.paused) {
				playVideo()
				homeVideoContainer.style.paddingBottom = '56.25%'
				homeVideoContainer.style.maxWidth = '100%'
				homeVideoText.classList.add('playing')
			} else {
				homeVideo.pause()
				homeVideoContainer.classList.remove('playing')
				homeVideoContainer.style.paddingBottom = ''
				homeVideoContainer.style.maxWidth = ''
				homeVideoText.classList.remove('playing')
			}
		}
		// mute / unmute
		homeVideoMuteBtn.addEventListener('click', function () {
			if (homeVideo.hasAttribute('muted')) {
				homeVideo.muted = false
				homeVideo.removeAttribute('muted')
				homeVideoMuteBtn.classList.add('mute')
				homeVideoMuteBtn.classList.remove('muted')
				homeVideoMuteBtn.innerHTML = 'Mute'
			} else {
				homeVideo.muted = true
				homeVideo.setAttribute('muted', true)
				homeVideoMuteBtn.classList.add('muted')
				homeVideoMuteBtn.classList.remove('mute')
				homeVideoMuteBtn.innerHTML = 'Unmute'
			}
		})
	}

	// MARK: Play quote video
	//   https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/play
	const quotesGroupVideos = document.querySelectorAll('.quotes-group-video')
	quotesGroupVideos.forEach(quotesGroupVideo => {
		const quotesVideo = quotesGroupVideo.querySelector('.quotes-video')

		if (quotesVideo) {
			quotesVideo.addEventListener('click', handlePlayButton, false)
			async function playVideo() {
				try {
					await quotesVideo.play()
					quotesGroupVideo.classList.add('playing')
				} catch (err) {
					quotesGroupVideo.classList.remove('playing')
				}
			}
			function handlePlayButton() {
				if (quotesVideo.paused) {
					playVideo()
				} else {
					quotesVideo.pause()
					quotesGroupVideo.classList.remove('playing')
				}
			}
		}
	})

	// MARK: Accordion
	const accordionContent = document.querySelectorAll('.accordion-content')

	accordionContent.forEach((item, index) => {
		let header = item.querySelector('.info-embed-accord-topic')
		header.addEventListener('click', () => {
			item.classList.toggle('is-open')

			let description = item.querySelector('.info-embed-accord-description')
			if (item.classList.contains('is-open')) {
				// Scrollheight property return the height of an element including padding
				description.style.height = `${description.scrollHeight}px`
			} else {
				description.style.height = '0px'
			}
			// removeOpenedContent(index)
		})

		// CED wants the accrodion items to stay open if another is opened.
		// And is why this is commented out.

		// function removeOpenedContent(index) {
		// 	accordionContent.forEach((item2, index2) => {
		// 		if (index != index2) {
		// 			item2.classList.remove('is-open')
		// 			let descrip = item2.querySelector('.info-embed-accord-description')
		// 			descrip.style.height = '0px'
		// 		}
		// 	})
		// }
	})

	// Slick carousel - ced 40 quotes
	const quoteCarousels = document.querySelectorAll('.quotes-block-40 > .quote-block-carousel')
	if ( quoteCarousels ) {
		for (let quoteCarousel of quoteCarousels) {
			jQuery(quoteCarousel).slick({
				autoplay: false,
				autoplaySpeed: 5000,
				dots: true,
			})
		}
	}

}
document.addEventListener('DOMContentLoaded', ready)
